import axios from 'axios'

// let testURL = 'http://doctor.pearlcare.cn/inquiry-api' // 线上环境

const request = axios.create({
  baseURL: process.env.BASE_API
})

/**
 *   config => {
    if (getToken()) {
      config.headers['Authorization'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    config.headers['Content-Type'] = 'application/json'
    return config
  },
 */

// 请求时拦截
request.interceptors.request.use(
  function (config) {
    config.headers.Authorization = localStorage.getItem('token')
    config.headers['Content-Type'] = 'application/json'
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

// 响应时拦截
request.interceptors.response.use(
  function (response) {
    return response.data
  },
  function (error) {
    return Promise.reject(error)
  }
)

export default request



// WEBPACK FOOTER //
// ./src/api/request.js